import { useSyncExternalStore } from 'react';
import { serverNow } from './clock-skew';

/**
 * TEK SANIYE NABZI.
 *
 * Listede yirmi kartin her birinin kendi `setInterval`i olsaydi yirmi zamanlayici
 * birbirinden bagimsiz kayardi ve ayni saniyede iki farkli sayac gorunurdu.
 * Burada TEK zamanlayici var; abone yoksa hic calismaz (test ortaminda ve
 * gecmis listelerinde bosuna tik atmaz).
 *
 * Deger `serverNow()` — cihaz saati DEGIL. Saati yanlis kurulmus bir cihazda
 * dogru veriye ragmen yanlis faz gostermek, kullanicinin sikayet edecegi ama
 * loglarda izi olmayan turden bir hatadir (bkz. clock-skew.ts).
 */

type Listener = () => void;

const listeners = new Set<Listener>();
let timer: ReturnType<typeof setInterval> | null = null;
let nowMs = serverNow();

const tick = (): void => {
  nowMs = serverNow();
  for (const listener of listeners) listener();
};

const subscribe = (listener: Listener): (() => void) => {
  listeners.add(listener);
  if (timer === null) {
    // Ilk abonede deger tazelenir: nabiz duruyorken gecen sure `nowMs`i bayat birakti.
    nowMs = serverNow();
    timer = setInterval(tick, 1000);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && timer !== null) {
      clearInterval(timer);
      timer = null;
    }
  };
};

const getSnapshot = (): number => nowMs;

/**
 * Pasif kartlarin abonesi. Modul seviyesinde SABIT bir kimlik: her render'da
 * yeni bir fonksiyon uretmek useSyncExternalStore'u her turda yeniden abone
 * olmaya zorlar ve sonsuz bir donguye donusur.
 */
const noopUnsubscribe = (): void => undefined;
const noopSubscribe = (): (() => void) => noopUnsubscribe;

/**
 * Saniyede bir tazelenen SUNUCU zamani.
 *
 * `active` false verildiginde abone olunmaz — pasif (sayaci bitmis) kartlar
 * listenin geri kalanini saniyede bir yeniden cizdirmesin diye.
 */
export const useServerTick = (active = true): number => {
  return useSyncExternalStore(active ? subscribe : noopSubscribe, getSnapshot, getSnapshot);
};

/** YALNIZ TESTLER ICIN — bekleyen zamanlayiciyi durdurur. */
export const resetServerTick = (): void => {
  if (timer !== null) clearInterval(timer);
  timer = null;
  listeners.clear();
  nowMs = serverNow();
};
